import React from "react"

import Header from "../../design-system/header"
import Title from "../../design-system/title"
import UniversalLink from "../../design-system/universal-link"
import { classNames } from "../../utils/class-names"
import BlogMetadata from "../blog-metadata"
import * as styles from "./index.module.scss"

interface Props {
  title: string
  date: string
  minutesOfReading: number
  url: string
  titleVariant?: "title-1" | "header-2" | "header-4"
  className?: string
}

const BlogTitleAndMetadata: React.FC<Props> = ({
  title,
  date,
  minutesOfReading,
  url,
  titleVariant = "header-4",
  className,
}) => {
  return (
    <UniversalLink
      to={url}
      className={classNames(styles.titleAndMetadata, className)}
    >
      {titleVariant === "title-1" ? (
        <Title variant="1" as="h3" className={styles.title}>
          {title}
        </Title>
      ) : (
        <Header
          variant={titleVariant.split("-")[1] as "2" | "4"}
          as="h3"
          className={styles.title}
        >
          {title}
        </Header>
      )}
      <BlogMetadata minutesOfReading={minutesOfReading} updatedAt={date} />
    </UniversalLink>
  )
}

export default BlogTitleAndMetadata
